<template>
  <div class="card">
    <div class="card-header">
      <b-btn v-b-toggle.collapse variant="link">
        Filters
      </b-btn>
    </div>
    <b-collapse id="collapse" class="mt-2">
      <form class="p-3" @submit.prevent="filter()">
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="logs-filter-webhook-type" v-model="filterWebhookType">
            <label class="form-check-label" for="logs-filter-webhook-type">Webhook</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="logs-filter-message-sent-type"
                   v-model="filterMessageSentType">
            <label class="form-check-label" for="logs-filter-message-sent-type">Message Sent</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="logs-filter-message-received-type"
                   v-model="filterMessageReceivedType">
            <label class="form-check-label" for="logs-filter-message-received-type">Message Received</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="logs-filter-message-forwarded-type"
                   v-model="filterMessageForwardedType">
            <label class="form-check-label" for="logs-filter-message-forwarded-type">Message Forwarded to
              Integration</label>
          </div>
        </div>

        <div>Status:</div>

        <div class="form-group">
          <div class="form-check form-check-inline">
            <input type="checkbox" class="form-check-input" id="logs-filter-status-error" v-model="filterStatusError">
            <label class="form-check-label" for="logs-filter-status-error">
              Error
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input type="checkbox" class="form-check-input" id="logs-filter-status-success"
                   v-model="filterStatusSuccess">
            <label class="form-check-label" for="logs-filter-status-success">
              Success
            </label>
          </div>
        </div>

        <button class="btn btn-primary" type="submit">Apply</button>
      </form>
    </b-collapse>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterWebhookType: true,
        filterMessageSentType: true,
        filterMessageReceivedType: true,
        filterMessageForwardedType: true,
        filterStatusError: true,
        filterStatusSuccess: true
      }
    },

    methods: {
      filter() {
        const filterParams = {
          type: this.resolveEventTypes(),
          status: this.resolveStatus()
        }
        this.$router.push({query: filterParams})
        this.$emit('filterChanged')
      },

      resolveStatus() {
        const statuses = []
        if (this.filterStatusError) statuses.push('error')
        if (this.filterStatusSuccess) statuses.push('success')

        return statuses.join()
      },

      resolveEventTypes() {
        const types = []
        if (this.filterWebhookType) types.push('webhook_sent')
        if (this.filterMessageSentType) types.push('message_sent')
        if (this.filterMessageReceivedType) types.push('message_received')
        if (this.filterMessageForwardedType) types.push('integration_forwarded')

        return types.join()
      }
    },

    mounted() {
      if (this.$route.query.type !== undefined) {
        this.filterWebhookType = this.$route.query.type.includes('webhook_sent')
        this.filterMessageSentType = this.$route.query.type.includes('message_sent')
        this.filterMessageReceivedType = this.$route.query.type.includes('message_received')
        this.filterMessageForwardedType = this.$route.query.type.includes('integration_forwarded')
      }
      if (this.$route.query.status !== undefined) {
        this.filterStatusError = this.$route.query.status.includes('error')
        this.filterStatusSuccess = this.$route.query.status.includes('success')
      }
    }
  }
</script>
